export default __webpack_public_path__ + "static/media/Azad.5e5b9017.webp";